import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import { MAP_CELL_MODES, MAP_HEADERS_STYLES } from './BaseTable.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const BaseTableNoSortable = styled.div `
  ${({ align }) => {
    return css `
      ${align === 'center' && `justify-content: center;`}
      ${align === 'left' && `justify-content: flex-start;`}
      ${align === 'right' && `justify-content: flex-end;`}

      // Box model
      align-items: center;
      display: flex;
    `;
}}
`;
export const BaseTableSortable = styled.button `
  ${({ align }) => {
    return css `
      // Box model
      align-items: center;
      border: none;
      display: flex;
      gap: ${getSpace('xs')};
      padding: 0;
      width: 100%;

      ${align === 'center' && `justify-content: center;`}
      ${align === 'left' && `justify-content: flex-start;`}
      ${align === 'right' && `justify-content: flex-end;`}

      // Colors.
      background-color: transparent;

      // Space.
      gap: ${getSpace('m')};

      // Miscellanea.
      cursor: pointer;
    `;
}}
`;
export const BaseTableTHRoot = styled.th `
  ${({ align, isSortable, mode, size }) => {
    const { paddingX, paddingY } = MAP_HEADERS_STYLES[size];
    const { thColorHover } = MAP_CELL_MODES[mode];
    return css `
      // Display & Box model.
      padding-bottom: ${getSpace(paddingY)};
      padding-left: ${getSpace(paddingX)};
      padding-right: ${getSpace(paddingX)};
      padding-top: ${getSpace(paddingY)};

      ${align && `text-align: ${align};`}

      ${isSortable &&
        `
        :hover {
          background-color: ${thColorHover};
        }
      `}
    }
  `;
}}
`;
//# sourceMappingURL=BaseTableTH.styled.js.map